// extracted by mini-css-extract-plugin
module.exports = {"comments":"T_dC","comments__list":"T_dD"};